var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-module download-card" },
    [
      _c("div", { staticClass: "module-title" }, [
        _c("i", {
          staticClass: "iconfont icon-shouji",
          staticStyle: { "font-size": "20px" },
        }),
        _vm._v(" " + _vm._s(_vm.$t("home.appDownloadMethod")) + " "),
      ]),
      _c("div", { staticClass: "app-item" }, [
        _vm._m(0),
        _c("div", { staticClass: "app-body" }, [
          _c("div", {
            staticClass: "qr-box",
            domProps: { innerHTML: _vm._s(_vm.qrCodeHtml) },
          }),
          _c(
            "div",
            { staticClass: "app-info" },
            [
              _c(
                "el-link",
                {
                  attrs: { underline: false, type: "primary" },
                  on: { click: _vm.copyLink },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.scanOrLinkDownload")) + " ")]
              ),
              _c("div", { staticClass: "url-text" }, [
                _vm._v(" " + _vm._s(_vm.urlData) + " "),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "app-item" }, [
        _vm._m(1),
        _c("div", { staticClass: "app-body" }, [
          _c(
            "div",
            { staticStyle: { margin: "20px 10px 0 0" } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: { placement: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("img", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              alt: "ios",
                              src: require("@/assets/images/Apple1.jpg"),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("img", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      alt: "ios",
                      src: require("@/assets/images/Apple1.jpg"),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "app-info" }, [
            _c(
              "div",
              { staticStyle: { "font-size": "15px", "font-weight": "500" } },
              [_vm._v(_vm._s(_vm.$t("home.searchAppStore")))]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-header" }, [
      _c("i", {
        staticClass: "iconfont icon-anzhuo",
        staticStyle: { "font-size": "20px" },
      }),
      _vm._v(" Android "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-header" }, [
      _c("i", {
        staticClass: "iconfont icon-pingguo",
        staticStyle: { "font-size": "20px" },
      }),
      _vm._v(" iOS"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }